import { Review, ReviewCard, ReviewPlatform } from "@/types/review";
import { bbbBadge, googleLogo } from "@/lib/gcsImagePaths";
import { trustpilotLogo } from "@/lib/gcsImagePaths";

export const reviewPlatforms: ReviewPlatform[] = [
  {
    name: "Trustpilot",
    logo: trustpilotLogo,
    rating: "",
    reviewCount: "",
    link: "https://www.trustpilot.com/review/guardianservice.com",
  },
  {
    name: "Google",
    logo: googleLogo,
    rating: "",
    reviewCount: "",
    link: "https://maps.google.com/?cid=4256186436518853756",
  },
  {
    name: "BBB",
    logo: bbbBadge,
    rating: "A-",
    reviewCount: null,
    link: "https://www.bbb.org/us/nc/raleigh/profile/insurance-agency/guardian-service-0593-90362894/",
  },
];

export const reviewSets: Review[][] = [
  [
    {
      name: "Vanessa M.",
      date: "2 weeks ago",
      text: "Guardian Service saved me over $1,800 a year on my home and auto insurance. The process was so easy and they found me better coverage for less money. I couldn't be happier!",
    },
    {
      name: "Grant K.",
      date: "1 month ago",
      text: "I was skeptical at first, but Guardian Service really delivered. They shopped around and found me a policy that saved me $2,700 annually. The customer service is outstanding.",
    },
    {
      name: "Estelle R.",
      date: "3 weeks ago",
      text: "After using Guardian Service, I realized I was underinsured by $8,800. They not only saved me money but also ensured I had proper coverage. Highly recommend!",
    },
  ],
  [
    {
      name: "Michael T.",
      date: "1 week ago",
      text: "The team at Guardian Service is professional and knowledgeable. They took the time to explain everything and found me significant savings. Great experience overall.",
    },
    {
      name: "Sarah L.",
      date: "2 months ago",
      text: "I've been with Guardian Service for over a year now. They continuously monitor my policies and always keep me informed about better options. Excellent service!",
    },
    {
      name: "David P.",
      date: "1 month ago",
      text: "Guardian Service made insurance shopping stress-free. They handled everything and saved me money in the process. I wish I had found them sooner!",
    },
  ],
  [
    {
      name: "Jennifer H.",
      date: "3 weeks ago",
      text: "The savings Guardian Service found for me were incredible. They're thorough, honest, and truly care about their clients. I've referred several friends to them.",
    },
    {
      name: "Robert M.",
      date: "2 weeks ago",
      text: "Professional, efficient, and results-driven. Guardian Service exceeded my expectations and saved me thousands. I'm a customer for life!",
    },
    {
      name: "Lisa C.",
      date: "1 month ago",
      text: "Guardian Service's approach to insurance is refreshing. They're transparent, helpful, and always looking out for my best interests. Highly recommend!",
    },
  ],
];

export const cheapHomeReviewCards: ReviewCard[] = [
  {
    title: "Professional and knowledgeable",
    text: "The team at Guardian Service is professional and knowledgeable. They took the time to explain everything and found me significant savings. Great experience overall.",
    author: "Michael T.",
    time: "1 week ago",
  },
  {
    title: "Excellent service!",
    text: "I've been with Guardian Service for over a year now. They continuously monitor my policies and always keep me informed about better options. Excellent service!",
    author: "Sarah L.",
    time: "2 months ago",
  },
  {
    title: "Stress-free experience",
    text: "Guardian Service made insurance shopping stress-free. They handled everything and saved me money in the process. I wish I had found them sooner!",
    author: "David P.",
    time: "1 month ago",
  },
  {
    title: "Incredible savings",
    text: "The savings Guardian Service found for me were incredible. They're thorough, honest, and truly care about their clients. I've referred several friends to them.",
    author: "Jennifer H.",
    time: "3 weeks ago",
  },
  {
    title: "Customer for life!",
    text: "Professional, efficient, and results-driven. Guardian Service exceeded my expectations and saved me thousands. I'm a customer for life!",
    author: "Robert M.",
    time: "2 weeks ago",
  },
  {
    title: "Highly recommend!",
    text: "Guardian Service's approach to insurance is refreshing. They're transparent, helpful, and always looking out for my best interests. Highly recommend!",
    author: "Lisa C.",
    time: "1 month ago",
  },
];
